import React from 'react';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import { SectionProps } from '../utils/SectionProps';
import Button from '../components/elements/Button';
import Input from '../components/elements/Input';
import { withTranslation } from "react-i18next";

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const SignUp = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const { register, handleSubmit,  } = useForm();

  const onSubmit = data => console.log(data);

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const {t} = props;
  return (
    <section
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              Ecomspy
            </h1>

            <div className="container-xs">
              <p className="m-0 mb-0 reveal-from-bottom" data-reveal-delay="400" style={{textAlign:'left'}}>
                {t("Create your Ecomspy account")}
              </p>

              <form
                onSubmit={handleSubmit(onSubmit)}
              >

                <Input
                  type="email" label="Subscribe" labelHidden hasIcon="right" placeholder={t("Enter your email")}
                  ref={register({required: true, pattern: /^\S+@\S+$/i})}
                  style={{margin:'20px 0'}}
                >

                </Input>

                <Input
                  type="password" label="Subscribe" labelHidden hasIcon="right" placeholder={t("Enter your password")}
                  ref={register} name="password"
                  style={{margin:'20px 0'}}
                >

                </Input>

                <Input
                  type="password" label="Subscribe" labelHidden hasIcon="right" placeholder={t("confirm your password")}
                  ref={register} name="passwordConfirmation"
                  style={{margin:'20px 0'}}
                >

                </Input>
                <p style={{textAlign:'left'}}>
                  {t("By submitting the form, you agree to our Terms of Use and Data Use Policy")}
                </p>
                <Button type="submit" tag="a" color="primary" wideMobile style={{width:'100%'}}>
                  {t("Register")}
                </Button>

                <div hidden id="timeLine"/>
                <div hidden id="pricing"/>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

SignUp.propTypes = propTypes;
SignUp.defaultProps = defaultProps;

export default withTranslation()(SignUp);
